import * as angular from "angular";
import {IController} from "angular";
import {ContentTemplateModel} from "../../../content-templates/models/content-template.model";
import * as _ from "lodash";
import {TextTriggerType} from "../../types/text-trigger.type";


export class WhatsappNotificationConfigurationFormComponent implements IController {

  notification: any;
  language: string;
  onSave: Function;

  public contentTemplate: ContentTemplateModel;
  public notificationCopy: any;
  public textTriggerType: typeof TextTriggerType = TextTriggerType;

  constructor() {
  }

  $onChanges(changes: angular.IOnChangesObject) {
    if (changes.notification && !changes.notification.isFirstChange()) {
      this.notificationCopy = angular.copy(this.notification);
    }
  }

  onSelectContentTemplate(contentTemplate, id) {
    this.contentTemplate = contentTemplate;
    this.notificationCopy.contentTemplateReference = undefined;
    this.notificationCopy.contentTemplateVariablesMap = {};

    if (!id) {
      _.unset(this.notificationCopy, 'contentTemplateId');
      _.unset(this.notificationCopy, 'contentTemplateVariablesMap');
    } else {
      this.notificationCopy.contentTemplateId = id;
      if (!!this.contentTemplate.variables) {
        this._initContentTemplateVariablesMap();
      }
    }
  }

  onChangeVariableValue(key, variable) {
    this.notificationCopy.contentTemplateVariablesMap[key] = variable;
  }

  save(form) {
    if (form) {
      form.$setSubmitted(true);
      if (form.$valid) {
        this.onSave({notification: this.notificationCopy});
      }
    }
  }

  onScheduleMessageSettingsScheduleTimeChange(dateObj, notification) {
    if (!(dateObj instanceof Date)) {
      notification.scheduleMessageSetting.scheduleTime = undefined;
    } else {
      var hh = dateObj.getHours().toString().padStart(2, '0');
      var mm = dateObj.getMinutes().toString().padStart(2, '0');

      notification.scheduleMessageSetting.scheduleTime = hh + ':' + mm;
    }

    this.notificationCopy = angular.copy(this.notification);
  }

  onScheduleBeforeInMinutesChange(days, notification) {
    notification.scheduleMessageSetting.scheduleBeforeInMinutes = !!days ?
        parseInt(days, 10) * 60 * 24 :
        undefined;
    this.notificationCopy = angular.copy(this.notification);
  }

  onToggleIgnoreLowQualityAddress() {
    this.notification.ignoreLowQualityAddress = !this.notification.ignoreLowQualityAddress
    this.notificationCopy = angular.copy(this.notification);
  }

  private _initContentTemplateVariablesMap() {
    for (const [key, value] of Object.entries(this.contentTemplate.variables)) {
      this.notificationCopy.contentTemplateVariablesMap[key] = undefined;
    }
  }

}

angular
  .module('bringoz.admin.notifications')
  .component('whatsappNotificationConfigurationForm', {
    bindings: {
      notification: '<',
      language: '<?',
      onSave: '&'
    },
    template: require('./whatsapp-notification-configuration-form.html').default,
    controller: WhatsappNotificationConfigurationFormComponent
  });
